"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _crmApi = require("@ys/crm-api");
var _common = require("@/constants/common");
var _default = exports.default = {
  name: 'MessageReadUser',
  props: {
    msgId: {
      type: String,
      required: true
    },
    type: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      messageReadUserStr: '',
      readList: [],
      unreadList: []
    };
  },
  mounted() {
    this.getReadStr();
    this.getReadList();
    this.getUnreadList();
  },
  methods: {
    async getReadStr() {
      const res = (await _crmApi.CrmYcMsgReadService.getMessageReadList({
        query: {
          pageNo: 1,
          pageSize: 3,
          msgId: this.msgId,
          type: this.type,
          status: _common.YesOrNoNum.Yes
        }
      })).data.data;
      if (!res.total) {
        this.messageReadUserStr = '0人已查看';
        return;
      }
      const name = res.records.map(item => item.userName).join('、');
      if (res.total < 3) {
        this.messageReadUserStr = `${name}已查看`;
      } else {
        this.messageReadUserStr = `${name}...共${res.total}人已查看`;
      }
    },
    async getReadList() {
      this.readList = (await _crmApi.CrmYcMsgReadService.getMessageReadList({
        query: {
          pageNo: 1,
          pageSize: 999,
          msgId: this.msgId,
          type: this.type,
          status: _common.YesOrNoNum.Yes
        }
      })).data.data.records;
    },
    async getUnreadList() {
      this.unreadList = (await _crmApi.CrmYcMsgReadService.getMessageReadList({
        query: {
          pageNo: 1,
          pageSize: 999,
          msgId: this.msgId,
          type: this.type,
          status: _common.YesOrNoNum.No
        }
      })).data.data.records;
    }
  }
};